// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dL2iY","box":"styles_box__dup9W","inner":"styles_inner__XtuH_","outside":"styles_outside__UMbC5","boxLogo":"styles_boxLogo__TXWh0"};